import {Component, HostListener} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-back-btn',
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss']
})
export class BackBtnComponent {

  constructor(
    private location: Location,
  ) {
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    // console.warn('AppComponent.onClick', $event);
    this.location.back(); // 이전 페이지로 돌아가기
  }
}
